module.exports = __webpack_public_path__ + "static/img/supplier-manage.c910d8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/supplier-manage.jpg
// module id = iK0r
// module chunks = 1